/*
* Base JS file
*/
$(function() {
  /* Multiple currencies */
  if ($('body').hasClass('currencies')) {
    $('#currency-picker-toggle a').click(function() {
      $('#currency-picker-toggle').hide();
      $('#currencies-picker').fadeIn();
      return false;
    });

    $('#currencies-picker select').change(function() {
      $('#currencies-picker').hide();
      $('#currency-picker-toggle').fadeIn();
      return true;
    }).blur(function() {
      $('#currencies-picker').hide();
      $('#currency-picker-toggle').fadeIn();
      return true;
    });
  }
    // Listing TOGGLE
    $('#list-toggle .plus-ico').each(function() {
            var tis = $(this), state = false, answer = tis.next('ul').slideUp();
            tis.click(function() {
                
                state = !state;
                answer.slideToggle(state);
                tis.toggleClass('active',state);
            });
            });
    });

	//initiate the plugin and pass the id of the div containing gallery images 
	$(".zoom-img").elevateZoom({
      	zoomType: "inner",
      	gallery:'gal1', 
      	cursor: 'pointer', 
      	galleryActiveClass: 'active', 
      	imageCrossfade: true
      }); 
	
	//Product details qiantity plus minus
	$(".plus-minus").on("click", function () {
        var $button = $(this);
        var $input = $button.closest('.sp-quantity').find("input.quntity-input");

        $input.val(function(i, value) {
            return +value + (1 * +$button.data('multi'));
        });
    });

	//TOOLTIP
	$('.ttip').tooltip();

	//Fix header on scroll
	$(function(){
      // Check the initial Poistion of the Sticky Header
      var stickyHeaderTop = $('#navbar-top').offset().top;

      $(window).scroll(function(){
        if( $(window).scrollTop() > stickyHeaderTop ) {
          $('#navbar-top').addClass("fixed");
          $('body').addClass("bg-top");
        } else {
          $('#navbar-top').removeClass("fixed");
          $('body').removeClass("bg-top");
        }
      });
    });
	
	//INFINITE SCROLLING
	$(function(){

      //var $container = $('.masonry-collection');
    
      //$container.isotope({
     //   itemSelector : '.main'
     // });
      
      var $container = $('.masonry-collection'),
            filters = {};
    isotope = function() {
        $container.isotope({           
            itemSelector: '.main'
        });
    };
      
      setTimeout(function() {
          isotope();

      }, 800);
      
      $container.infinitescroll({
        loading: {
            img: "data:image/gif;base64,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",
            msgText: 'Loading More Videos..',
            finishedMsg: 'No More Videos To Show!'
        },
        navSelector: '#__nav-video-lib-pagi', // selector for the paged navigation 
        nextSelector: '#__nav-video-lib-pagi a:first', // selector for the NEXT link (to page 2)
        itemSelector: '.masonry-collection .main' // selector for all items you'll retrieve           
        },
        function(newElements) {
            $(newElements).hide();
            $container.imagesLoaded(function() {
                $(newElements).fadeIn();            
                $container.isotope('appended', newElements);
                isotope();

            });
        }
        );
      
    
    });




/* Show/Hide Cart Note */
$('#cart-note').on('show.bs.collapse', function(){
  $('.cart-note-action').hide();
});
$('#cart-note').on('shown.bs.collapse', function(){
  $(this).find('#note').focus();
});

var preloadProductImages = function(){
  var $thumbs = $('[data-main-image]');
  if($thumbs.length > 0){
    $thumbs.each(function(){
      var image = new Image();
      image.src = $(this).attr('data-main-image');
    });
  }
};

/* Carousel control heights */
var carouselControlHeight = function(){
  var imgHeight = $('.carousel').find('.item.active img').height();
  $('.carousel-control').css({maxHeight: imgHeight});
};

/* Product Image Switcher */
$('[data-main-image]').click(function(event) {
  var targetImage = $(this).attr('data-main-image');
  var $mainImage = $('#main');
  if($mainImage.attr('src') !== targetImage){
    $mainImage.hide().attr('src', targetImage).fadeIn();
  }
  event.preventDefault();
});

/* window events */
$(window).load(function(){
  preloadProductImages();
  
  carouselControlHeight();
  $('.carousel').on('slid.bs.carousel', function(){
    carouselControlHeight();
  });
});

$(window).on('resize', function(){
  carouselControlHeight();
});
/* Facebook gallery via https://gist.github.com/alexdunae/1239554 */

(function(){
  var title = $('#facebook-title'),
  link = $('#facebook-link'),
  viewer = $('#facebook-viewer'),
  thumbs = $('#facebook-thumbs'),
  gallery_id = thumbs.attr('data-album');
  
  if(thumbs.length > 0){
    // album info
    $.getJSON('//graph.facebook.com/' + gallery_id + '?callback=?', function(json) {
      title.html('<a href="' + json.link + '" title="View album on Facebook" target="_blank">' + json.name + '</a>');
      link.html('<i class="fa fa-fw fa-facebook-square text-muted"></i> <a href="' + json.link + '" title="View album on Facebook" target="_blank">View album on Facebook</a>');
    });

    // images
    $.getJSON('//graph.facebook.com/' + gallery_id + '/photos?callback=?', function(json) {
      var imgs = json.data;

      viewer.attr('src', imgs[0].images[0].source);

      for (var i = 0, l = imgs.length - 1; i < l; i++) {
        $('<div class="col-sm-3"><img class="thumbnail" src="' + imgs[i].images[2].source + '" data-fullsize="' + imgs[i].images[0].source + '"></div>').appendTo(thumbs);
      }

      $('img', thumbs).bind('click', function(e) {
        e.preventDefault();
        viewer.attr('src', $(this).attr('data-fullsize'));
      });
    });
  }
}());
/* Recover password form */

function getID(id){ // http://jsperf.com/getelementbyid-vs-jquery-id/44
  return jQuery(document.getElementById(id));
}

var recoverForm = getID('customer-recover-password-form'),
loginForm = getID('customer-login-form');

function showRecoverPasswordForm() {
  recoverForm.parent().show();
  loginForm.parent().hide();
}

function hideRecoverPasswordForm() {
  recoverForm.parent().hide();
  loginForm.parent().show();
}

$('.hide-recover-password-form').on('click', function(e){
  hideRecoverPasswordForm();
  e.preventDefault();
});

$('.show-recover-password-form').on('click', function(e){
  showRecoverPasswordForm();
  e.preventDefault();
});

// dont show links if we dont have both includes present
if(recoverForm === null){ getID('forgotten-password-link').style.display='none'; }
if(loginForm === null){ getID('recover-password-link').style.display='none'; }

hideRecoverPasswordForm();
if (window.location.hash === '#recover') { showRecoverPasswordForm(); }
